import {BaseModel} from "../baseModel";
import {IsEmail, IsNotEmpty} from "class-validator";
import {MeetsPasswordCriteria} from "../../validators/meetsPasswordCriteria.validator";

class User extends BaseModel 
{
    @IsEmail({blacklisted_chars: "+"}, { message : "Please enter a valid email"})
    @IsNotEmpty({ message: "Please enter a valid email" })
    userName: string;
}
class UserWithPassword extends User 
{
    @MeetsPasswordCriteria({message: "Please enter a password that meets the requirements"})
    @IsNotEmpty({message: "Please enter a password that meets the requirements"})
    password: string;
}

class Login
{
    @IsEmail({blacklisted_chars: "+"}, { message : "Please enter your email"})
    @IsNotEmpty({ message: "Please enter your email" })
    userName: string;
    
    @IsNotEmpty({message: "Please enter your password"})
    password: string;
}

export {User, UserWithPassword, Login}